export default "__VITE_ASSET__11bc4189__"